import React from "react";
import { withRouter } from "react-router-dom";

import { CONSENT_TO_TREATMENT } from "@/core/constants";
import { getQueryParams } from "@/utils/filters";
import { Policy } from "@/components/Policy/Policy";

function TreatmentPolicyPage(props) {
  const version = getQueryParams("version", props.location.search);

  return <Policy policyType={CONSENT_TO_TREATMENT} version={version} />;
}

export default withRouter(TreatmentPolicyPage);
